import React from "react";

import { faArrowDownToLine, faEllipsis } from "@performyard/fontawesome/pro-solid-svg-icons";
import { DropDownMenu, type DropDownMenuOption, Icon } from "@performyard/py-components";
import { ASYNC_TASK_NAMES } from "@performyard/service-contracts";

import DownloadButtonSSE from "../../../../components.smart/DownloadButtonSSE";

import { useUserAsyncTask } from "../../../../hooks/useUserAsyncTask";

import { exportWorkspaceMeetingsCsv } from "../../../../api/services/defs/internal-api";

import { convertFiltersToExportParams } from "../utils";

import type { MeetingsTableFilters } from "../schema";

type PageActionsDropdownProps = {
	workspaceId: string;
	filters: MeetingsTableFilters;
	userId: string;
};

const PageActionsDropdown = ({ workspaceId, filters, userId }: PageActionsDropdownProps): React.ReactElement => {
	const { task: exportTask, triggerTask: triggerExport } = useUserAsyncTask(
		ASYNC_TASK_NAMES.EXPORT_WORKSPACE_MEETINGS_CSV
	);

	const handleDownloadCsv = async (): Promise<void> => {
		// Convert UI filters to the format expected by the export Lambda
		// Pass userId so private notes filter can be user-specific
		const exportFilters = convertFiltersToExportParams(filters, userId);

		await triggerExport(() =>
			exportWorkspaceMeetingsCsv(workspaceId, {
				filters: exportFilters,
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			})
		);
	};

	const handleDropDownSelect = (key: string): void => {
		switch (key) {
			case "DownloadCSV": {
				handleDownloadCsv();
				break;
			}
			default:
				break;
		}
	};

	const actionsDropDown: DropDownMenuOption[] = [
		{
			key: "DownloadCSV",
			label: "Download CSV",
			right: <Icon icon={faArrowDownToLine} size={16} color="neutral-5" />,
		},
	];

	return (
		<>
			<DropDownMenu
				options={actionsDropDown}
				onSelect={handleDropDownSelect}
				minWidth={170}
				placement="bottom-end"
				bordered
			>
				<Icon icon={faEllipsis} size={16} />
			</DropDownMenu>
			<div style={{ display: "none" }}>
				<DownloadButtonSSE task={exportTask} onClick={handleDownloadCsv} testid="download-csv">
					Download CSV
				</DownloadButtonSSE>
			</div>
		</>
	);
};

export default PageActionsDropdown;
